import { Link } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { Button, Card, PageHeader } from "@/components/primitives";

export function JourneysPage() {
  const saved = JSON.parse(
    window.localStorage.getItem("cosmos:journeys") ?? "[]"
  ) as Array<{ id: string; title: string; summary: string }>;

  return (
    <div className="page">
      <PageHeader
        eyebrow="Journeys"
        title="Learning journey commands"
        subtitle="Draft journeys from Cosmos recommendations and submit guarded write requests."
        actions={
          <Link to="/journeys/new">
            <Button>
              <Plus size={16} /> Create journey
            </Button>
          </Link>
        }
      />
      <div className="card-grid">
        {saved.length === 0 && (
          <Card>
            <h2>No saved drafts yet</h2>
            <p>Create a journey command from a prompt or from the workspace.</p>
          </Card>
        )}
        {saved.map((journey) => (
          <Link key={journey.id} to="/journeys/$journeyId" params={{ journeyId: journey.id }}>
            <Card>
              <h2>{journey.title}</h2>
              <p>{journey.summary}</p>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
